function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { SIZES } from '../config';
import { size4 } from '../../theme/scale';
import * as COLORS from '../../theme/colors';
import { elevationFour } from '../../theme/elevations';
import { z10 } from '../../theme/z-index';
const Wrapper = styled.table`
  ${({
  minWidth
}) => minWidth && `min-width: ${minWidth};`}
  border-collapse: separate;
  border-spacing: 0;
  display: table;
  overflow-y: visible;
  width: 100%;

  thead {
    > tr {
      background: ${({
  striped,
  headerBackground
}) => headerBackground ? headerBackground : striped ? COLORS.white : COLORS.gray50}
    }

    > th {
      ${({
  striped,
  border
}) => striped && !border && `border-bottom: 1px solid ${COLORS.gray300};`}
      ${({
  sticky
}) => sticky && `
        position: sticky;
        top: 0;
        z-index: ${z10};
      `}
    }
  }

  ${({
  $radius
}) => $radius && `
    thead {
      tr {
        th {
          &:first-of-type {
            border-radius: ${size4} 0 0 0;
          }
          &:last-of-type {
            border-radius: 0 ${size4} 0 0;
          }
        }
      }
    }
    tbody {
      tr {
        &:last-of-type {
          th,
          td {
            &:first-of-type {
              border-radius: 0 0 0 ${size4};
            }
            &:last-of-type {
              border-radius: 0 0 ${size4} 0;
            }
          }
        }
      }
    }
  `}

  tbody {
    > tr {
      ${({
  striped
}) => striped && `
        &:nth-child(odd) {
          background: ${COLORS.gray50};
        }
      `}
    }
  }

  tr {
    height: ${({
  size
}) => SIZES[size].height};
  }

  td,
  th {
    ${({
  border
}) => border && `
      border-bottom: 1px solid ${COLORS.gray400};

      &:not(:last-of-type) {
        border-right: 1px solid ${COLORS.gray400};
      }
    `}

    font-size: ${({
  size
}) => SIZES[size]['font-size']};
    padding: ${({
  size
}) => SIZES[size].padding};
  }
`;
const Footer = styled.div`
  border-top: 1px solid ${COLORS.gray300};
`;
const Container = styled.div`
  ${({
  border
}) => border && `border: 1px solid ${COLORS.gray400};`}
  ${({
  maxHeight
}) => maxHeight && `max-height: ${maxHeight}; overflow-y: auto;`}
  ${({
  $radius
}) => $radius && `border-radius: ${size4};`}
  ${({
  minWidth
}) => minWidth && '-webkit-overflow-scrolling: touch; overflow-x: auto; overscroll-behavior-x: contain;'}
  ${({
  $elevation
}) => $elevation && `box-shadow: ${elevationFour};`}
  background: ${COLORS.white};
`;
export const Table = ({
  children,
  footer,
  minWidth,
  maxHeight,
  border = true,
  radius = false,
  striped = false,
  sticky = false,
  size = 'md',
  elevation = false,
  headerBackground,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Container, {
    $elevation: elevation,
    $radius: radius,
    border,
    maxHeight,
    minWidth
  }, /*#__PURE__*/React.createElement(Wrapper, _extends({
    $radius: radius,
    size,
    border,
    striped,
    sticky,
    minWidth,
    headerBackground
  }, props), children), footer && /*#__PURE__*/React.createElement(Footer, null, footer));
};
export default Table;
//# sourceMappingURL=index.js.map